import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_URL } from "../../constants/api";
import { format } from "date-fns";
import { PendingRestaurantReviewPageContext } from "../../App";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { Tooltip } from "bootstrap/dist/js/bootstrap.bundle.min.js";
import Slider from "react-slick";
import { RestaurantReviewTabContext } from "../../pages/restaurantReview/AllRestaurantReviewPage";
const AllPendingRestaurantReviewLayer = () => {
  const [records, setRecords] = useState([]);
  const [data, setData] = useState(null);
  const token = localStorage.getItem("pfp-token");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [activeModal, setActiveModal] = useState(null);
  const [reviewModal, setReviewModal] = useState(null);
  const [update, setUpdate] = useState(0);
  const { pendingRestaurantReviewPage, setPendingRestaurantReviewPage } = useContext(
    PendingRestaurantReviewPageContext
  );
  const {updateTab, setUpdateTab} = useContext(RestaurantReviewTabContext)
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [search, setSearch] = useState("");
  const [reasons, setReason] = useState("");
  const [reviewImages, setReviewImages] = useState([]);
  const [review, setReview] = useState("");

  // Trigger the modal by setting the active row's ID
  const handleModalOpen = (id) => {
    setActiveModal(id);
  };

  // Close the modal
  const handleModalClose = () => {
    setActiveModal(null);
  };
  // Trigger the modal by setting the active row's ID
  const handleReviewModalOpen = (id, review, files) => {
    setReviewModal(id);
    setReviewImages(files);
    setReview(review);
  };

  // Close the modal
  const handleReviewModalClose = () => {
    setReviewModal(null);
    setReviewImages([]);
    setReview("");
  };

  useEffect(() => {
    const fetchAllRecipes = async () => {
      if (search.trim() !== "") {
        await setLimit(10);
        await setPendingRestaurantReviewPage(1);
      }

      try {
        setLoading(true);

        const searchParams = new URLSearchParams({
          offset: pendingRestaurantReviewPage,
          limit: limit,
          search_term: search,
          is_approved: "pending",
        });
        const response = await fetch(
          `${API_URL}/api/backend/restaurant/reviews/list?${searchParams}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const json = await response.json();

        if (response.ok) {
          const sortedData = json.data.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          setRecords(sortedData);
          setData(sortedData);
          setLastPage(json.pagination.last_page);
          setTotal(json.pagination.total);
        } else {
          setRecords([]);
        }
      } catch (error) {
        alert(error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllRecipes();
  }, [update, limit, pendingRestaurantReviewPage, search, updateTab]);


  const handleApprove = async (approved, id) => {
    const data = approved === "rejected" ? { approved, reasons } : { approved };

    const response = await fetch(
      `${API_URL}/api/backend/restaurant/reviews/approval/${id}`,
      {
        method: "PATCH",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "Application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const json = await response.json();

    if (response.ok) {
      toast.success(json.message);
      setUpdate(update + 1);
      if (approved === "rejected") {
        handleModalClose();
      }
    }
  };

  return (
    <div className="card h-100 p-0 radius-12">
      <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
        <div className="d-flex flex-wrap align-items-center gap-3">
          {activeModal && (
            <div
              className="modal fade show"
              tabIndex={-1}
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
              style={{ display: "block", backdropFilter: "blur(5px)" }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <form
                  className="modal-content"
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleApprove("rejected", activeModal);
                  }}
                >
                  <div className="card">
                    <div className="card-header d-flex">
                      <h5 className="card-title mb-0">Reason</h5>
                      <button
                        type="button"
                        className="btn-close ms-auto"
                        onClick={handleModalClose}
                      ></button>
                    </div>
                    <div className="card-body">
                      <div className="row gy-3">
                        <div className="col-12">
                          <textarea
                            type="text"
                            name="#0"
                            className="form-control"
                            placeholder="Explain reason of rejection"
                            onChange={(e) => setReason(e.target.value)}
                            rows={5}
                            required
                          />
                        </div>

                        <div className="col-12 d-flex justify-content-end">
                          <button
                            type="submit"
                            className="btn btn-sm btn-danger-600"
                          >
                            Confirm Reject
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          )}
          {reviewModal && (
            <div
              className="modal fade show"
              tabIndex={-1}
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
              style={{ display: "block", backdropFilter: "blur(5px)" }}
            >
              <div className="modal-dialog modal-dialog-centered  modal-lg">
                <div className="col-sm-12 modal-content">
                  <div className="card p-0 overflow-hidden position-relative radius-12">
                    <div className="card-header py-16 px-24 bg-base border border-end-0 border-start-0 border-top-0 d-flex justify-content-between">
                      <h6 className="text-lg mb-0">Review</h6>
                      <button
                        type="button"
                        className="btn-close ms-auto"
                        onClick={handleReviewModalClose}
                      ></button>
                    </div>
                    <div className="card-body p-0 arrow-carousel">
                      <p className="text-center  py-2">{review}</p>
                      <div className="container-fluid mb-4">
                        <div className="row">
                          {reviewImages.length > 0 ? (
                            reviewImages.map((image, index) => (
                              <div className="col-auto m-1">
                                <img
                                  src={image.cdn_image_small}
                                  alt={`Review ${index + 1}`}
                                  className="w-120-px h-120-px radius-8 object-fit-cover"
                                  style={{height: "200px"}}
                                />
                              </div>
                            ))
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="d-flex align-items-center gap-2">
            <span>Show</span>
            <select
              className="form-select form-select-sm w-auto"
              defaultValue={limit}
              onChange={(e) => setLimit(parseInt(e.target.value))}
            >
              <option value={limit} disabled>
                {limit}
              </option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
          <div className="icon-field">
            <input
              type="text"
              name="#0"
              className="form-control form-control-sm w-auto"
              placeholder="Search"
              onChange={(e) => setSearch(e.target.value)}
            />
            <span className="icon">
              <Icon icon="ion:search-outline" />
            </span>
          </div>
        </div>
      </div>

      <div className="card-body p-24">
        <div className="table-responsive scroll-sm">
          <table className="table bordered-table sm-table mb-0">
            <thead>
              <tr>
                <th scope="col">
                  <div className="d-flex align-items-center gap-10">
                    <div className="form-check style-check d-flex align-items-center"></div>
                    ID
                  </div>
                </th>

                <th scope="col">User</th>
                <th scope="col">Restaurant Name</th>
                <th scope="col">Review</th>
                <th scope="col" className="text-center">
                 Food
                </th>
                <th scope="col" className="text-center">
                 Service
                </th>
                <th scope="col" className="text-center">
                 Ambiance
                </th>
                <th scope="col" className="text-center">
                 Variety
                </th>
                <th scope="col" className="dt-orderable-asc dt-orderable-desc">
                  Date Reviewed
                </th>
                <th scope="col" className="text-center">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {records &&
                records.map((user) => (
                  <tr key={user.id}>
                    <td>
                      <div className="d-flex align-items-center gap-10">
                        {user.id}
                      </div>
                    </td>

                    <td>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {user.user_name}
                      </span>
                    </td>

                    <td>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {user.restaurant_name}
                      </span>
                    </td>
                    <td>
                      <span
                        className="my-tooltip-button badge text-sm fw-semibold text-primary-600 bg-primary-100 px-20 py-9 radius-4 text-white"
                        type="button"
                        onClick={() =>
                          handleReviewModalOpen(
                            user.id,
                            user.review,
                            user.files
                          )
                        }
                      >
                        View
                      </span>
                    </td>
                    <td className="">
                      <div className="d-flex justify-content-center align-items-center">
                        <ul className="d-flex flex-wrap align-items-center ">
                          <li className="text-warning-600  line-height-1">
                            <Icon icon="material-symbols:star" />
                          </li>
                        </ul>
                        <span className="line-height-1"> {user.food}</span>
                      </div>
                    </td>
                    <td className="">
                      <div className="d-flex justify-content-center align-items-center">
                        <ul className="d-flex flex-wrap align-items-center ">
                          <li className="text-warning-600  line-height-1">
                            <Icon icon="material-symbols:star" />
                          </li>
                        </ul>
                        <span className="line-height-1"> {user.service}</span>
                      </div>
                    </td>
                    <td className="">
                      <div className="d-flex justify-content-center align-items-center">
                        <ul className="d-flex flex-wrap align-items-center ">
                          <li className="text-warning-600  line-height-1">
                            <Icon icon="material-symbols:star" />
                          </li>
                        </ul>
                        <span className="line-height-1"> {user.ambiance}</span>
                      </div>
                    </td>
                    <td className="">
                      <div className="d-flex justify-content-center align-items-center">
                        <ul className="d-flex flex-wrap align-items-center ">
                          <li className="text-warning-600  line-height-1">
                            <Icon icon="material-symbols:star" />
                          </li>
                        </ul>
                        <span className="line-height-1">{user.variety}</span>
                      </div>
                    </td>
                    <td>{format(user.created_at, "dd MMM, yyyy")}</td>
                    <td className="text-center">
                      <div className="d-flex align-items-center gap-10 justify-content-center">
                        <button
                          type="button"
                          className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                        >
                          <Icon
                            icon="mdi:approve"
                            className="icon text-xl"
                            onClick={() => handleApprove("approved", user.id)}
                          />
                        </button>

                        <button
                          type="button"
                          onClick={() => handleModalOpen(user.id)}
                          className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                        >
                          <Icon
                            icon="charm:circle-cross"
                            className="menu-icon"
                          />
                        </button>
                    
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
          <span>
            Showing {limit} of {total} entries
          </span>
          <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
            {pendingRestaurantReviewPage > 1 ? (
              <li className="page-item">
                <button
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px  text-md"
                  onClick={
                    pendingRestaurantReviewPage > 1
                      ? () =>
                          setPendingRestaurantReviewPage(
                            pendingRestaurantReviewPage - 1
                          )
                      : () =>
                          setPendingRestaurantReviewPage(pendingRestaurantReviewPage)
                  }
                >
                  <Icon icon="ep:d-arrow-left" className="" />
                </button>
              </li>
            ) : (
              <></>
            )}

            {pendingRestaurantReviewPage > 2 ? (
              <li className="page-item">
                <button
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                  onClick={() =>
                    setPendingRestaurantReviewPage(pendingRestaurantReviewPage - 2)
                  }
                >
                  {pendingRestaurantReviewPage - 2}
                </button>
              </li>
            ) : (
              <></>
            )}
            {pendingRestaurantReviewPage > 1 ? (
              <li className="page-item">
                <button
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                  onClick={() =>
                    setPendingRestaurantReviewPage(pendingRestaurantReviewPage - 1)
                  }
                >
                  {pendingRestaurantReviewPage - 1}
                </button>
              </li>
            ) : (
              <></>
            )}

            <li className="page-item">
              <Link
                className="page-link text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md bg-primary-600 text-white"
                to="#"
              >
                {pendingRestaurantReviewPage}
              </Link>
            </li>

            {pendingRestaurantReviewPage < lastPage ? (
              <li className="page-item">
                <button
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                  onClick={() =>
                    setPendingRestaurantReviewPage(pendingRestaurantReviewPage + 1)
                  }
                >
                  {pendingRestaurantReviewPage + 1}
                </button>
              </li>
            ) : (
              <></>
            )}
            {pendingRestaurantReviewPage + 1 < lastPage ? (
              <li className="page-item">
                <button
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                  onClick={() =>
                    setPendingRestaurantReviewPage(pendingRestaurantReviewPage + 2)
                  }
                >
                  {pendingRestaurantReviewPage + 2}
                </button>
              </li>
            ) : (
              <></>
            )}
            {pendingRestaurantReviewPage !== lastPage ? (
              <li className="page-item">
                <button
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px  text-md"
                  onClick={() =>
                    setPendingRestaurantReviewPage(pendingRestaurantReviewPage + 1)
                  }
                >
                  {" "}
                  <Icon icon="ep:d-arrow-right" className="" />{" "}
                </button>
              </li>
            ) : (
              <></>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AllPendingRestaurantReviewLayer;
